var general = {

    // Nick wanted the code/alternate names disabled for now. 
    // So I've disabled them.
    showAlternateNames: false,

    listen: function () {

        $(".datepicker").datepicker({
            dateFormat: "dd/mm/yy"
        });

        // https://forums.select2.org/t/search-being-unfocused/1203/8
        $(document).on('select2:open', () => {
            document.querySelector('.select2-container--open .select2-search__field').focus();
        });


        $("#driver_view_form select").on("change", function() {
            $("#driver_view_form").trigger("submit");
        })

        general.initSelect2($("body"));
        general.initHardwareSelect2($("body"));

        $("[name=shipping_estimate]").on("change", function(event) {
            event.preventDefault();
            var element = $(this);
            var val = element.val();

            if (val == "Other") {
                $(".shipping_estimate_other_container").show();
            } else {
                $(".shipping_estimate_other_container").hide();
                $("[name=shipping_estimate_other]").val("");
            }
        })
        
        /**
         * Tooltips: Init and then hook into livewire update. 
         * I'll have to manually re-init where new cards are added etc.
         */
        general.initTooltips();
        $(document).on('livewire:update', general.initTooltips());

        /**
         * Sometimes we want a text field to be numbers only (but not show the up/down buttons etc from a number field).
         */
        $(document).on('input', '.numeric-input, .discount-input', function (event) {
            general.restrictInputToNumeric(event, $(this));
        });

        /**
         * Global event handler so we can trigger Toastr notifications from Livewire.
         * 
         * Note: using window.addEventListener instead of jQuery's $(window).on() because
         * Livewire fires native CustomEvents via window.dispatchEvent(), and jQuery strips
         * event.detail from the normalised event object.
         */
        window.addEventListener('notify', function (event) {
            general.handleNotify(event);
        });

        /**
         * "Send To Customer" on a quote renders a PDF server-side (Browsershot) before
         * sending, which can take a while. It's a plain link (full page GET, not ajax),
         * so guard against the user clicking it again while that request is in flight by
         * disabling it and swapping in a spinner. The browser's own navigation for this
         * first click still goes ahead as normal.
         */
        $(document).on('click', '.js-send-to-customer-btn', function (event) {
            var $btn = $(this);

            if ($btn.hasClass('disabled')) {
                event.preventDefault();
                return;
            }

            $btn.addClass('disabled');
            $btn.html('<i class="fas fa-spinner fa-spin me-1"></i> Sending...');
        });

    },

    /**
     * Global Livewire notification handler.
     *
     * Livewire components can fire browser events like:
     * $this->dispatch('notify', type: 'success', message: '...')
     * and toastr will pick them up here.
     */
    handleNotify: function(event) {
        let detail = event.detail;
        let type = detail.type || 'success';
        let message = detail.message || '';

        if (typeof toastr === 'undefined') {
            console.warn('toastr is not available for notify event:', message);
            return;
        }

        const typeMap = {
            success: toastr.success,
            error:   toastr.error,
            warning: toastr.warning,
            info:    toastr.info,
        };

        if (typeMap[type]) {
            typeMap[type].call(toastr, message);
        }
    },

    /**
     * Sometimes we want a text field that only allows numeric values (instead of using a number field)
     * so we don't get the annoying up/down buttons and scroll behaviour.
     * 
     * For .discount-input fields, a trailing "%" is also allowed (e.g. "10%").
     * 
     * @param {JavaScript event} event 
     * @param {jQuery element} element 
     */
    restrictInputToNumeric: function(event, element) {

        let isDiscount = element.hasClass('discount-input');

        // For discount fields allow digits, "." and a trailing "%". For everything else, digits and "." only.
        let value = isDiscount
            ? element.val().replace(/[^0-9.%]/g, '')
            : element.val().replace(/[^0-9.]/g, '');

        // Only allow % at the end, not mid-string (e.g. "1%0" → "10")
        if (isDiscount) {
            value = value.replace(/%(?=.)/g, '');
        }

        // Strip % before doing numeric checks, we'll re-append it after if needed
        let hasPercent = isDiscount && value.endsWith('%');
        let numeric = value.replace('%', '');

        // Don't allow multiple "."
        const parts = numeric.split('.');
        if (parts.length > 2) {
            numeric = parts[0] + '.' + parts.slice(1).join('');
        } 
        
        // Only allow 2dp
        else if (parts.length === 2) {
            numeric = parts[0] + '.' + parts[1].slice(0, 2);
        }

        // Re-append % if it was there
        if (hasPercent) {
            numeric += '%';
        }

        element.val(numeric);

    },

    /**
     * Initialise any bootstrap tooltips (only if they're not already initialised).
     */
    initTooltips: function() {
        $('[data-bs-toggle="tooltip"]').each(function() {
            if (!bootstrap.Tooltip.getInstance(this)) {
                new bootstrap.Tooltip(this);
            }
        });
    },

    /**
     * Build the label shown for a hardware search select2 option / selection.
     *
     * Hardware search only - the other Cin7 selects keep showing the plain product name.
     *
     * While general.showAlternateNames is false there's no muted detail line, so the code is
     * folded into the label itself as "[code] name" - that way the code is still visible without
     * the two-line treatment. When the detail line is switched back on we return the plain name
     * and leave the code to buildCin7DetailLine, so we're not showing it twice.
     *
     * Values are stringified before comparison for the same reason as buildCin7DetailLine -
     * jQuery's .data() coerces a numeric data-* attribute to a Number, which would never === the
     * string name.
     *
     * @param {string} text - the main product name (the option text)
     * @param {string} code - the product code (may be undefined/empty)
     */
    buildCin7OptionLabel: function (text, code) {

        text = (text || "").toString().trim();
        code = (code || "").toString().trim();

        if (general.showAlternateNames) {
            return text;
        }

        // Nothing useful to prefix with, or the code is just repeating the name.
        if (!code || code == text) {
            return text;
        }

        return "[" + code + "] " + text;
    },

    /**
     * Build the muted detail line (alternate name / code) shown under a Cin7 select2 option.
     *
     * Gated behind general.showAlternateNames so the client can switch the whole lot off in one
     * place. Only shows the alternate name / code when they have a value AND differ from the main
     * product name, so we never just repeat the name back to the user.
     *
     * Values are stringified before comparison because jQuery's .data() will auto-coerce a numeric
     * data-* attribute (e.g. a numeric code) to a Number, which would never === the string name.
     *
     * Returns a jQuery <div> ready to append, or null if there's nothing to show.
     *
     * @param {string} text - the main product name (the option text)
     * @param {string} alt - the alternate name (may be undefined/empty)
     * @param {string} code - the product code (may be undefined/empty)
     */
    buildCin7DetailLine: function (text, alt, code) {
        
        if (!general.showAlternateNames) {
            return null;
        }

        // I was getting a bunch of whitespace on these.
        text = text.trim();
        alt = alt.trim();
        code = code.trim();

        let details = [];

        // Only show if there's a value and it isn't just repeating the main name.
        if (alt && alt != text) {
            details.push("Alternate Name: " + alt);
        }
        if (code && code != text) {
            details.push("Code: " + code);
        }

        if (!details.length) {
            return null;
        }

        return $("<div class='text-muted small'></div>").text(details.join(" | "));
    },

    /**
     * Initialise Select2 elements in a given scope.
     * 
     * NOTE: Apparently select2 creates its elements against the body, and if you have elements with the same name
     * (for example the spec sheet and the edit door modal) and you try to re-initialise even inside specifically
     * the edit door modal, a select2 with that name already exists and causes issues.
     * 
     * @param {jQuery el} scope 
     */
    initSelect2: function (scope) {

        console.log("Initialising Select2");
    
        scope.find(".select2").each(function() {
    
            var element = $(this);
            
            // Skip if already initialized
            if (element.data('select2')) {
                console.log("Select2 already initialized on:", element.attr("name"));
                return;
            }
            
            var options = { 
                placeholder: element.attr("placeholder"),
                minimumResultsForSearch: Infinity,
                width: 'auto',
                dropdownAutoWidth: true,
                templateResult: general.cin7DropdownTemplate,
                matcher: general.cin7DropdownMatcher,
            }
    
            // Put the search functionality back with a class.
            if (element.hasClass("select2-search") || element.hasClass("searchable")) {
                options.minimumResultsForSearch = 0;
                options.tags = false;
                options.createTag = null;
                options.selectOnClose = false;
            }
    
            // If it's in a modal we need to do this so the z-index works out ok
            if (element.hasClass("select2-in-modal")) {
                options.dropdownParent = element.closest(".modal-content");
            }
    
            if (element.hasClass("select2-tags")) {
                options.minimumResultsForSearch = 0;
                options.tags = true;
            }
    
            // Support creating new options inline (like contacts)
            if (element.hasClass("select2-allow-new")) { 
                console.log("APPLYING select2-allow-new options to:", element.attr("name"));
                options.minimumResultsForSearch = 0;
                options.tags = true;
                options.createTag = function (params) {
                    var term = $.trim(params.term);
                    
                    if (term === '') {
                        return null;
                    }
                    
                    return {
                        id: term,
                        text: term + ' (new)',
                        newTag: true
                    }
                };
                options.templateResult = function(data) {
                    if (data.newTag) {
                        return $('<span><i class="fas fa-plus-circle"></i> ' + data.text + '</span>');
                    }
                    return general.cin7DropdownTemplate(data);
                };
            }
    
            var name = element.attr("name");
            if (name == "arch_type" || name == "arch_type[]") {
                options.maximumSelectionLength = 2;
            }
            
    
            element.select2(options);
        });
    },

    initHardwareSelect2: function (scope) {

        console.log("Initialising Hardware Search Select2");

        scope.find(".select2-hardware-search").each(function() { 

            var element = $(this);
            
            var options = {
                ajax: {
                    url: element.data("url"), // /quotes/hardware-search
                    dataType: 'json',
                    delay: 250,
                    data: function (params) { 
                        var tr = element.closest("tr.hardware_list_line");
                        var supplierCin7Id = $('[name="hardware_supplier_cin7_id[]"]', tr);
            
                        return {
                            query: params.term, // user's input
                            supplierCin7Id: supplierCin7Id.val()
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: $.map(data.results, function (item) {
                                return {
                                    id: item.product_name,
                                    text: item.product_name,
                                    code: item.code,
                                    alternateName: item.alternate_name,
                                    style: item.hardware_style,
                                    finish: item.hardware_finish,
                                    supplierId: item.harware_supplier_cin7_id,
                                };
                            })
                        };
                    }, 
                    cache: true
                },
                minimumInputLength: 3, // Minimum characters before making an Ajax request
                tags: true,
                dropdownAutoWidth: true,
                width: 'auto', 
                
                // Move these here
                templateResult: function (data) {
                    if (!data.id) {
                        return data.text;
                    }

                    let option = $("<span></span>");
                    option.append(document.createTextNode(general.buildCin7OptionLabel(data.text, data.code)));

                    // Show the alternate name and code (if any) on a new line underneath.
                    let detailLine = general.buildCin7DetailLine(data.text, data.alternateName, data.code);
                    if (detailLine) {
                        detailLine.appendTo(option);
                    }

                    return option;
                },
                templateSelection: function (data) {
                    if (!data.id) {
                        return data.text;
                    }

                    let alt = data.alternateName;
                    let code = data.code;

                    // On page load the selected option is rendered server-side, so the AJAX
                    // fields aren't set - fall back to the option's data-* attributes.
                    if (typeof alt === "undefined" && data.element) {
                        alt = $(data.element).data("alternate-name");
                    }
                    if (typeof code === "undefined" && data.element) {
                        code = $(data.element).data("code");
                    }

                    let selection = $("<span></span>");
                    selection.append(document.createTextNode(general.buildCin7OptionLabel(data.text, code)));

                    let detailLine = general.buildCin7DetailLine(data.text, alt, code);
                    if (detailLine) {
                        detailLine.appendTo(selection);
                    }

                    return selection;
                }
            };
            
            element.select2(options);

            // The two-line selection needs the single-selection box to expand rather than clip.
            element.next(".select2-container").addClass("select2-two-line");
        });
    },

    /**
     * Select2 template for the Cin7 dropdowns. Shows the product name on top, with the alternate
     * name and code (pulled from the option's data-alternate-name / data-code) on a muted line
     * underneath, e.g. "Alternate Name: Foo | Code: BAR". Only shows the parts that are present,
     * and falls through to plain text when there's neither, so it's safe on every select2.
     * 
     * Returns a jQuery object (rather than an HTML string) so we don't have to flip escapeMarkup
     * globally - select2 only escapes string returns, DOM nodes are inserted as-is.
     * 
     * @param {select2 result} state 
     */
    cin7DropdownTemplate: function (state) {

        if (!state.id) {
            return state.text;
        }

        let alt = state.alternateName;
        let code = state.code;

        // Older select2 builds don't always copy data-* onto state - fall back to the element.
        if (typeof alt === "undefined" && state.element) {
            alt = $(state.element).data("alternate-name");
        }
        if (typeof code === "undefined" && state.element) {
            code = $(state.element).data("code");
        }

        let option = $("<span></span>");
        option.append(document.createTextNode(state.text));

        // Build the detail line underneath - only the parts we actually have.
        let detailLine = general.buildCin7DetailLine(state.text, alt, code);
        if (detailLine) {
            detailLine.appendTo(option);
        }

        return option; 
    },

    /**
     * Select2 matcher for the Cin7 dropdowns. Default select2 only searches the option text
     * (the product name), so this also matches against the alternate name and code held in the
     * option's data-* attributes.
     *
     * @param {object} params - the search params (params.term is what the user typed)
     * @param {object} data - the option being tested
     */
    cin7DropdownMatcher: function (params, data) {

        // No search term - show everything.
        if ($.trim(params.term) === "") {
            return data;
        }

        // Optgroups: recurse into children, keep the group if any child matches.
        if (data.children && data.children.length) {
            let matches = [];
            for (let i = 0; i < data.children.length; i++) {
                let child = general.cin7DropdownMatcher(params, data.children[i]);
                if (child) {
                    matches.push(child);
                }
            }
            if (matches.length) {
                let group = $.extend({}, data);
                group.children = matches;
                return group;
            }
            return null;
        }

        // Skip options without a value (the "None Selected" placeholder etc).
        if (data.id === undefined || data.id === null || data.id === "") {
            return null;
        }

        let alt = data.alternateName;
        let code = data.code;

        // Same as the template - select2 usually copies data-* onto the object, but fall back to the element.
        if (typeof alt === "undefined" && data.element) {
            alt = $(data.element).data("alternate-name");
        }
        if (typeof code === "undefined" && data.element) {
            code = $(data.element).data("code");
        }

        let term = params.term.toLowerCase();

        // When the extra details are switched off, only search the product name - matching on the
        // now-hidden alt/code would surface results with no visible reason for the match.
        let haystack = general.showAlternateNames
            ? (data.text + " " + (alt || "") + " " + (code || "")).toLowerCase()
            : data.text.toLowerCase();

        return haystack.indexOf(term) > -1 ? data : null;
    },

    /*
     * Scrolls to a door card element and flashes it with a yellow highlight. Trying to keep it consistant.
     * 
     * @param {jQuery} cardElement - The card element to scroll to and flash
     */
    flashCard: function(cardElement) {
        $('html, body').animate({ scrollTop: cardElement.offset().top - 100 }, 300, function() {
            let headersAndFooters = cardElement.find('.card-header, .card-footer');
            headersAndFooters.css('background-color', '#ffff99');
            headersAndFooters.animate(
                { backgroundColor: 'rgb(247, 247, 247)' }, 
                1000
            );
        });
    }

}

$(function () {
    general.listen()
});

module.exports = {
    general
};